{
  "columnResizer": "Groottewijziging van kolom",
  "loading": "Laden...",
  "loadingMore": "Meer laden...",
  "resizeColumn": "Kolomgrootte wijzigen",
  "sortAscending": "Oplopend sorteren",
  "sortDescending": "Aflopend sorteren"
}
